var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PopupTemplate',{on:{"close":function($event){return _vm.close()}}},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.asunto))]),_c('p',[_vm._v(" "+_vm._s(_vm.mensaje)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }